import {
  addMonths,
  format,
  formatDistanceToNow,
  subDays,
  subMonths,
} from "date-fns";

// ----------------------------------------------------------------------

export function fDate(date) {
  return date ? format(new Date(date), "MM/dd/yyyy") : "";
}

export function fDate1(date) {
  return date ? format(new Date(date), "yyyy/MM/dd") : null;
}
export function exportDate(date) {
  return format(new Date(date), "MM-dd-yyyy_HHmmss");
}

export function fDateTime(date) {
  return date ? format(new Date(date), "MMM-dd-yyyy HH:mm") : null;
}

export function fDateTimeSuffix(date) {
  return date ? format(new Date(date), "dd/MM/yyyy hh:mm a") : null;
}
export function formatDateTimeAMPM(date) {
  return date ? format(new Date(date), "MM/dd/yyyy hh:mm a") : null;
}

export function formatDateTimeAMPMWith24(date) {
  return date ? format(new Date(date), "MM/dd/yyyy HH:mm a") : null;
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
      addSuffix: true,
    })
    : null;
}
export function fDate12(date) {
  return date ? format(new Date(date), "MMM-dd-yyyy  p") : null;
}

export function getCurrentDate() {
  return format(new Date(), "MM/dd/yyyy");
}
export function getCurrentTime() {
  return format(new Date(), "hh:mm:ss");
}

export function getFutureDate(month) {
  const currentDate = new Date();
  const futureDate = addMonths(currentDate, month);
  return format(futureDate, "MM/dd/yyyy");
}

export function getPastDate(month) {
  const currentDate = new Date();
  const pastDate = subMonths(currentDate, month);
  return format(pastDate, "MM/dd/yyyy");
}

export function MinDate() {
  return new Date("01/01/1900");
}

export function Today() {
  return new Date(); // returns current date as a Date object
}

export function formatDate(date) {
  if (!date) return "";

  const d = new Date(date);

  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert 0 → 12

  return `${month}/${day}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

